import FaqIcon from './FaqIcon';

export default FaqIcon;
